/* External Imports */
import { Box, SimpleGrid, Image } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@app-ila/components/Utility/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/**
 * Renders the Card Info 4 Card component
 * @param {Object} sectionContent - Data for section
 * @param {string} region - Region of the page
 * @param {string} lang - Language of the page
 * @returns {ReactElement} CardInfo4 Card component
 */

const WhoThisCards = ({ cards }) => {
  return (
    <Box maxW="1127px" mx="auto" width="100%">
      <SimpleGrid
        display="flex"
        justifyContent={{ base: 'center', md: 'center', xl: 'space-between' }}
        flexDirection={{ base: 'column', lg: 'row' }}
        alignItems={{ base: 'center', md: 'unset' }}
        flexWrap={{ base: 'wrap', xl: 'nowrap' }}
        rowGap="20px"
        columnGap="15px"
      >
        {cards?.map((secCon, index) => {
          const margin = (index + 1) % 2 === 0 ? '0px' : 0;
          return (
            <Box
              textColor="#fff"
              pos="relative"
              key={nanoid()}
              w={{ base: '100%', sm: '100%', md: '100%', lg: '257px' }}
              bgRepeat="no-repeat"
              mt={{
                base: '0',
                xl: margin,
              }}
              borderLeft={{ base: 'none', lg: index !== 0 ? '2px dotted #FFFFFF5C' : 'none'}}
            >
              <Box display="flex" alignItems="flex-start" height="100%">
                <Box p={{base:'20px', lg:'20px 0px 20px 40px'}}>
                  <Box
                    display={{base:'flex', lg:'block'}}
                    flexDirection="row"
                    alignItems={{ base: 'center', lg: 'flex-start' }}
                    mb={{ base: '0px', lg: '30px' }}
                  >
                    <Box display={{base:'inline-block', lg:'block'}} width={{base:'20%', lg:'100%'}} mb={{base:'0px', md:'30px'}}><Image src={secCon?.thumbnail?.url} /></Box>
                    <Box
                      fontSize="24px"
                      lineHeight="26px"
                      fontWeight="semibold"
                      letterSpacing="0em"
                      textAlign="left"
                      // fontFamily="var(--FedraSansCondensedMedium), sans-serif"
                      fontFamily="var(--FedraSansStd-book), sans-serif"
                      pb="4px"
                      display={{base:'inline-block', lg:'block'}} 
                      width={{base:'70%', lg:'100%'}}
                      pl={{base:'10px', lg:'0'}}
                    >
                      {secCon.title}
                    </Box>
                  </Box>
                  <Box
                    mt={{base: '6px', lg:'16px' }}
                    fontSize="16px"
                    lineHeight="160%"
                    fontWeight={400}
                    letterSpacing="0em"
                    textAlign="left"
                  >
                    <StructuredTextParser
                      str={render(secCon.description)}
                      region="in"
                      lang="en"
                      mt="0"
                      color="#D4D4FA"
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        })}
      </SimpleGrid>
    </Box>
  );
};

export default WhoThisCards;
